import get from 'lodash/get';

import { apiAction } from 'bento-ordering/base/utils/apiHelpers';
import { logError } from 'logging';
import {
  CREATE_ORDER_WITHOUT_CHECKOUT_ENDPOINT,
  CREATE_ORDER_WITHOUT_CHECKOUT_REQUEST,
  CREATE_ORDER_WITHOUT_CHECKOUT_SUCCESS,
  CREATE_ORDER_WITHOUT_CHECKOUT_FAILURE,
  SET_SEAT_ID_ON_CART_REQUEST,
  SET_SEAT_ID_ON_CART_SUCCESS,
  SET_SEAT_ID_ON_CART_FAILURE,
  SET_SEAT_ID_ON_CART_ENDPOINT
} from 'bento-ordering/investor_day/constants.js';

export const createOrderWithoutCheckout = (
  setIsSubmitting,
  setOrderValidationError
) => async dispatch => {
  const endpoint = CREATE_ORDER_WITHOUT_CHECKOUT_ENDPOINT;
  try {
    const response = await dispatch(
      apiAction(endpoint, 'PUT', [
        CREATE_ORDER_WITHOUT_CHECKOUT_REQUEST,
        CREATE_ORDER_WITHOUT_CHECKOUT_SUCCESS,
        CREATE_ORDER_WITHOUT_CHECKOUT_FAILURE
      ])
    );

    if (response.error) {
      const message = get(response, 'payload.response.error');
      setOrderValidationError(message);
    } else {
      setIsSubmitting(false);
      const { receipt_url } = response.payload;
      window.location.replace(receipt_url);
    }
  } catch (err) {
    logError(err);
  }
};

export const setSeatIdOnCart = seatId => async dispatch => {
  const endpoint = SET_SEAT_ID_ON_CART_ENDPOINT;
  const payload = {
    seating_identifier_value: seatId
  };

  return dispatch(
    apiAction(
      endpoint,
      'PATCH',
      [
        SET_SEAT_ID_ON_CART_REQUEST,
        SET_SEAT_ID_ON_CART_SUCCESS,
        SET_SEAT_ID_ON_CART_FAILURE
      ],
      payload
    )
  );
};
